
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/blockWeatherWidget';

const defaultSettings = {};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({});
